import React from 'react';
import _ from 'lodash';
import {useSelector} from 'react-redux';
import {
  Icon, Label, Menu,
} from 'semantic-ui-react';
import {closeMenu, openMenu} from './actions';
import { getCart } from '../../views/Cart/reducer';
import {getTasks} from "../../views/Tasks/reducer";
import {SERVICE_TASK_LEVEL_PREPARING, SERVICE_TASK_LEVEL_WORKING} from "../../config/config";

export default function NavBottomBar (props) {

  const {menuVisible, dispatch, navigate, token} = props;

  const getCartQuantity = useSelector((state) => getCart(state.cart));
  const tasks = useSelector((state) => getTasks(state.tasks));

  const sortPreparing = _.filter(tasks, { task_status_level: SERVICE_TASK_LEVEL_PREPARING}).length;
  const sortWorking = _.filter(tasks, { task_status_level: SERVICE_TASK_LEVEL_WORKING}).length;

  function showSidebar(e) {
    e.stopPropagation();
    dispatch( menuVisible ? closeMenu() : openMenu());
  }

  return (
      <Menu
          fluid
          secondary
          id="nav-bottom-bar"
          className="nav-bottom-bar"
          fixed="bottom"
          color="blue"
          icon="labeled"
          inverted
      >
        <Menu.Item className="shop-icon-item" onClick={() => navigate("/")}>
            <Icon name="home" size="tiny" className="shop-icon" />
            <div className="shop-text-item">Продукты</div>
        </Menu.Item>
          <Menu.Item name="tasks" className="shop-icon-item" onClick={() => navigate("/tasks")}>
            <Icon name="tasks" size="tiny" className="shop-icon"/>
            {sortPreparing + sortWorking && token ?
                <Label
                    color={tasks.task_status_level
                        ? "blue"
                        : "orange"
                }
                    size="mini"
                    floating
                    circular
                    content={sortPreparing + sortWorking > 99 ? "99+" : sortPreparing + sortWorking}
                    className="task-counter"
                />
                :  ''
            }
              <div className="shop-text-item">Задачи</div>
          </Menu.Item>
          <Menu.Item className="shop-icon-item" onClick={() => navigate("/cart")}>
            <Icon name="shopping basket" size="tiny" className="shop-icon" />
            {_.isEmpty(getCartQuantity) ? '' :
                <Label
                    color="blue"
                    size="mini"
                    floating
                    circular
                    content={getCartQuantity.length}
                    className="cart-counter"
                />
            }
              <div className="shop-text-item">Корзина</div>
          </Menu.Item>
          <Menu.Item className="shop-icon-item" onClick={showSidebar}>
          <Icon name="content" size="tiny" className="shop-icon" />
              <div className="shop-text-item">Меню</div>
          </Menu.Item>
      </Menu>
  );
}